var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Stickers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Stickers",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67349142,7.33338221 C5.86012572,7.33338221 6.01142272,7.48460989 6.01142272,7.67115869 C6.01142272,7.85770748 5.86012572,8.00893516 5.67349142,8.00893516 C5.48685711,8.00893516 5.33556012,7.85770748 5.33556012,7.67115869 C5.33556012,7.58157479 5.37116349,7.49566003 5.4345379,7.43231465 C5.49791231,7.36896927 5.58386646,7.33338221 5.67349142,7.33338221",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23283692,13.0400269 C5.36112225,15.1816508 7.58282264,16.5229567 10.0043478,16.5244579 C10.2778756,16.5227578 10.5510655,16.5049493 10.8224973,16.4711247",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,9.57337357 C19.7666207,4.11103074 15.187631,-0.151378825 9.72001617,0.00412271646 C4.25240139,0.159624258 -0.0767041446,4.67538425 0.00103066029,10.1421537 C0.0787654651,15.6089231 4.5345202,20 10.0043478,20 L10.4489943,20",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1831154,7.92004661 C12.559175,7.32283168 13.215699,6.96047481 13.921683,6.96047481 C14.6276671,6.96047481 15.2841911,7.32283168 15.6602507,7.92004661",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 9.57337357,
    x2: 10.4489943,
    y2: 19.9911111,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4489943,19.9911111 L10.4489943,19.1022257 C10.4588042,13.8367116 14.7320632,9.57337357 20,9.57337357",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickers);
export default __webpack_public_path__ + "static/media/Stickers.b817725b3a93db67a6be05b45828643a.svg";
export { ForwardRef as ReactComponent };